(function() {
    const VipService = function($http, CONSTANTS) {
        this.datiMito = null;

        this.reset = () => {
            this.datiMito = null;
        };

        this.getDatiCliente = (ndg) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA + '/' + ndg
            });
        };
        
        this.search = (input) => {
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_MITO8_ROOT + CONSTANTS.REST.AUDIT.SEARCH,
                data: input
            });
        };
        
        this.autentica = (codiceUtente, otp) => {
            const params = {
                codiceUtente: codiceUtente,
                idUtente: '',
                idCredenziale: '',
                nome: '',
                otp1: otp,
                otp2: ''
            };
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.VIP.AUTENTICA,
                data: params
            });
        };
        
        this.inviaPush = (codiceUtente) => {
            const params = {
                codiceUtente: codiceUtente,
                idUtente: '',
                idCredenziale: '',
                nome: '',
                otp1: '',
                otp2: ''
            };
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.VIP.PUSH,
                data: params
            });
        };
    };

    VipService.$inject = [ '$http', 'Mitom_CONSTANTS' ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomVipService', VipService);
})();